module.exports = __webpack_public_path__ + "img/2_Dicks_Screen_2_R.a3e4d06c.jpg";